// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-odds[data-v-11e7fea1]{height:calc(100% - 5px) !important;padding:0 !important}.btn-odds span[data-v-11e7fea1]{font-weight:800 !important}.btn-odds+.btn-odds[data-v-11e7fea1]{margin-left:2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
